<form #formulario="ngForm">
    <fieldset class="bordas">
        <mat-accordion>

            <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>Dados do material</mat-panel-title>
                </mat-expansion-panel-header>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                    <!-- MATERIAL -->
                    <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                        <mat-label>Material:</mat-label>
                        <mat-select [(ngModel)]="materiaisPrograma.material.id" name="material" required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let e of materiais" [value]="e.id">
                                {{e.nome}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="materiais?.length === 0" align="start">Nenhum material cadastrado</mat-hint>
                    </mat-form-field>

                    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                        <input matInput name="dtImplantacao" [matDatepicker]="dataInicio"
                            placeholder="Data de início de alocação:" [(ngModel)]="materiaisPrograma.dataInicio">
                        <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicio></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="15%">
                        <input matInput name="dtTermino" [matDatepicker]="dataTermino"
                            placeholder="Data de fim de alocação:" [(ngModel)]="materiaisPrograma.dataFim">
                        <mat-datepicker-toggle matSuffix [for]="dataTermino"></mat-datepicker-toggle>
                        <mat-datepicker #dataTermino></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                        <input [(ngModel)]=materiaisPrograma.quantidadeMaterial type="number" min=0 
                               matInput  
                               name="quantidadeMaterial" placeholder="Quantidade de materiais" />
                    </mat-form-field>

                    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                        <input currencyMask matInput maxlength="50" name="valorMaterial"
                            placeholder="Valor do material:" [(ngModel)]="materiaisPrograma.vlMaterial"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>
                </div>


                <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                    style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                    <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                        Limpar
                    </button>

                    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                        fxFlex="20%" color="primary" (click)="adicionar()">
                        Adicionar material
                    </button>

                    <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                        fxFlex="20%" color="primary" (click)="atualizar()">
                        Atualizar material
                    </button>

                </div>

            </mat-expansion-panel>


            <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                (closed)="openFormCadastro = true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Lista de Materiais dos Parceiros ( {{listaMateriaisPrograma?.length}} )
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                    style="margin-top: 20px">

                    <ng-container matColumnDef="material">
                        <th mat-header-cell *matHeaderCellDef> Código </th>
                        <td mat-cell *matCellDef="let element"> {{element.material.nome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="dataInicio">
                        <th mat-header-cell *matHeaderCellDef> Data Início:</th>
                        <td mat-cell *matCellDef="let element">{{element.dataInicio | dataSimples}} </td>
                    </ng-container>

                    <ng-container matColumnDef="dataFim">
                        <th mat-header-cell *matHeaderCellDef> Data Fim:</th>
                        <td mat-cell *matCellDef="let element">{{element.dataFim | dataSimples}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valorMaterial">
                        <th mat-header-cell *matHeaderCellDef> Valor:</th>
                        <td mat-cell *matCellDef="let element">{{element.vlMaterial}} </td>
                    </ng-container>

                    <ng-container matColumnDef="acoes">
                        <th mat-header-cell *matHeaderCellDef> Ações </th>
                        <td mat-cell *matCellDef="let element">
                            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizarComposicao(element)">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div [hidden]="!mostrarTabela">
                    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
                </div>

                <ng-template #tabelaSemDados>
                    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                        {{msg}}
                    </div>
                </ng-template>

                <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                    style="padding-top: 30px">
                    <div>
                        <button matTooltip="Adicionar nova material" mat-fab color="primary" (click)="novo()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>


            </mat-expansion-panel>

        </mat-accordion>
    </fieldset>
</form>